module.exports = __webpack_public_path__ + "static/media/400415_02.8e3c8ecc.png";